import React from 'react';

import { Column } from 'app/shopify/components/layout';

import { ProductTile } from './ProductTile';

export function ProductTileShowcase() {
  return (
    <Column gap="spacing.general.x4" padding="spacing.general.x4">
      <ProductTile orientation="vertical" />
      <ProductTile orientation="horizontal" />
    </Column>
  );
}
